export const textosAdministrarSecciones = {
  titulo: 'Todas las secciones',
  terminar: 'Terminar',
  congelada: 'Congelada: su enlace muestra lo que tenía antes de cambiar de nombre',
};
